import { render, staticRenderFns } from "./_botLog.vue?vue&type=template&id=2be0d2d2&scoped=true&lang=pug&"
import script from "./_botLog.vue?vue&type=script&lang=js&"
export * from "./_botLog.vue?vue&type=script&lang=js&"
import style0 from "./_botLog.vue?vue&type=style&index=0&id=2be0d2d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be0d2d2",
  null
  
)

export default component.exports